import { render, staticRenderFns } from "./OnboardingWelcomeDialog.vue?vue&type=template&id=176c1ed3&scoped=true&"
import script from "./OnboardingWelcomeDialog.vue?vue&type=script&lang=js&"
export * from "./OnboardingWelcomeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c1ed3",
  null
  
)

export default component.exports